export default "__VITE_ASSET__43730b17__$_?nuxt_component=async__"